import type { ProportionStripSpec } from './proportion-strip.js';

/**
 * Dry air by volume: nitrogen 78.08 %, oxygen 20.95 %, argon 0.93 %, carbon
 * dioxide 0.04 %. Rounded to two decimals these sum to exactly 100.00, and the
 * last two together are under 1 % — invisible at true scale, which is why the
 * figure magnifies that slice rather than fattening the bands.
 */
export function proportionStripFixture(width = 640, focusPartId = 'carbon-dioxide'): ProportionStripSpec {
  return {
    id: 'dry-air-composition',
    family: 'proportion-strip',
    view: 'orthographic',
    viewport: { width, height: 384 },
    subject: 'Dry air',
    unit: '%',
    parts: [
      { id: 'nitrogen', label: 'Nitrogen', value: 78.08 },
      { id: 'oxygen', label: 'Oxygen', value: 20.95 },
      { id: 'argon', label: 'Argon', value: 0.93 },
      { id: 'carbon-dioxide', label: 'Carbon dioxide', value: 0.04, amount: '0.04 % · 421 ppm' },
    ],
    total: 100,
    magnifyPartIds: ['argon', 'carbon-dioxide'],
    focusPartId,
    title: 'Carbon dioxide is 0.04 % of the air, and that is the whole point',
    subtitle: 'The strip stays exact, so the smallest part has to be enlarged honestly rather than drawn larger than it is.',
    provenance: 'Standard dry-air composition by volume, rounded to 0.01 %; CO₂ mole fraction ≈ 421 ppm (2023 global mean)',
  };
}
